import { AppPlatformEnums, ThemeNameEnums } from "@/utils/enum";
/**
 * 颜色主题
 */
export const ThemeColorMap = {
  [AppPlatformEnums.GT]: {
    themeColor: "#FFCF00", // 系统主题色
    textColor: "#FFB900", // 文字颜色
    btnBgColor: "#FFCF00", // 按钮背景色
    requireColor: "#FFB900", // 必填*颜色
    btnTextColor: "#262626", // 按钮文字颜色
    bgColor: "#FFFAE7", // 淡色背景色
    tagBgColor: "#FFFAE7" // 标签背景色
  },
  [AppPlatformEnums.GR]: {
    themeColor: "#034FA4", // 系统主题色
    textColor: "#0F58B9", // 文字颜色
    requireColor: "#F74E3B", // 必填*颜色
    btnBgColor: "#F1131F", // 按钮背景色
    btnTextColor: "#fff", // 按钮文字颜色
    bgColor: "#E7EEF8", // 淡色背景色
    tagBgColor: "#fff" // 标签背景色
  }
};
export const setPlatformTheme = (platform = AppPlatformEnums.GT) => {
  const themeMap = {
    "--theme-color--": ThemeColorMap[platform].themeColor,
    "--theme-text-color--": ThemeColorMap[platform].textColor,
    "--theme-require-color--": ThemeColorMap[platform].requireColor,
    "--theme-btn-bg-color--": ThemeColorMap[platform].btnBgColor,
    "--theme-btn-text-color--": ThemeColorMap[platform].btnTextColor,
    "--theme-bg-color--": ThemeColorMap[platform].bgColor,
    "--theme-tag-bg-color--": ThemeColorMap[platform].tagBgColor
  };
  // 添加主题样式
  document.body.classList.add(ThemeNameEnums[platform]);
  // 添加css变量
  Object.entries(themeMap).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
};



// WEBPACK FOOTER //
// ./src/utils/theme.js